import React, {memo, ReactNode} from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";

interface Props {
    icon?: ReactNode;
    title?: string;
    size?: "small" | "medium";
    multiline?: boolean;
    variant?: "outlined" | "filled" | "standard";
    rows?: number;
    maxRows?: number;
    name: string;
    value?: string;
    defaultValue?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    bgColor?: string;
    maxLength?: number;
    onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (value: React.FocusEvent<HTMLInputElement>) => void;
}

function MonoInputField(
    { 
        icon, 
        title, 
        size, 
        multiline, 
        variant, 
        rows, 
        maxRows, 
        name, 
        value, 
        defaultValue, 
        required, 
        disabled, 
        placeholder, 
        bgColor, 
        maxLength, 
        onChange,
        onBlur,
    }: Props) {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();

        if (onChange) {
            onChange(event);
        }
    };

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        event.preventDefault();

        if (onBlur) {
            onBlur(event);
        }
    };

    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <TextField
                required={required}
                name={name}
                placeholder={placeholder}
                variant={variant ? variant : "outlined"}
                size={size}
                defaultValue={defaultValue}
                value={value}
                onChange={handleInputChange}
                onBlur={handleBlur}
                multiline={multiline}
                rows={rows}
                maxRows={maxRows}
                fullWidth
                disabled={disabled}
                slotProps={{
                    input: {
                        startAdornment: icon && (
                            <InputAdornment
                                sx={{
                                    padding: "5px",
                                }}
                                position="start"
                            >
                                {icon}
                            </InputAdornment>
                        ),
                        sx: {
                            fontFamily: 'monospace, monospace !important',
                            fontSize: '14px !important',
                            fontStyle: 'normal !important',
                            lineHeight: '20px !important',
                            letterSpacing: '0em !important',
                            textAlign: 'left !important',

                            backgroundColor: bgColor ? bgColor : 'background.paper',
                        },
                    },

                    htmlInput: {
                        maxLength: maxLength,
                    }
                }} />
        </Box>
    );
}

export default memo(MonoInputField);
